import { render } from "./LinksInstitucionais.vue?vue&type=template&id=6006d46b"
import script from "./LinksInstitucionais.vue?vue&type=script&lang=js"
export * from "./LinksInstitucionais.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__